import React from 'react';
import ReactDOM from 'react-dom';
import Register from '../Register';

type RegisterProps = {
  redirect: string;
  isModal: string;
};

const RegisterView: React.FC<RegisterProps> = ({
  redirect,
  isModal,
}) => {
  return (
    <Register
      redirect={redirect}
      isModal={isModal === 'true'}
    />
  );
};

export default RegisterView;

document.querySelectorAll('.react-register-component')
  .forEach((element) => {
    const redirect = element.getAttribute('data-redirect') || '';
    const isModal = element.getAttribute('data-is-modal') || '';
    ReactDOM.render(<RegisterView
      redirect={redirect}
      isModal={isModal}
    />, element);
  });
